/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services';

interface ComplianceStatsResponse {
  message: string;
  status: boolean;
  data: {
    statistics: {
      totalUsers: number;
      verifiedCount: number;
      pendingCount: number;
    };
    categorizedUsers: {
      verified: {
        users: any[];
        totalCount: number;
      };
      pending: {
        users: any[];
        totalCount: number;
      };
    };
  };
}

export const complianceActions = {
  getUserDashboardStats,
};

function getUserDashboardStats(params?: {
  page?: number;
  limit?: number;
  includeUsers?: boolean;
}): Promise<ComplianceStatsResponse['data']> {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  if (params?.includeUsers !== undefined)
    queryParams.append('includeUsers', params.includeUsers.toString());

  const url = queryParams.toString()
    ? `/admin/users/dashboard-stats?${queryParams.toString()}`
    : '/admin/users/dashboard-stats';

  return services
    .get<ComplianceStatsResponse>(url)
    .then((promise) => {
      if (promise && 'data' in promise && promise.data.status) {
        return promise.data.data;
      } else {
        // Check for authentication errors
        if (promise?.status === 401) {
          return Promise.reject('Authentication required. Please log in again.');
        } else if (promise?.status === 403) {
          return Promise.reject('Access denied. Admin privileges required.');
        } else {
          return Promise.reject('Error fetching user dashboard statistics');
        }
      }
    })
    .catch((error) => {
      // Handle network or other errors
      if (error?.response?.status === 401) {
        return Promise.reject('Authentication required. Please log in again.');
      } else if (error?.response?.status === 403) {
        return Promise.reject('Access denied. Admin privileges required.');
      } else {
        return Promise.reject(error?.message || 'Error fetching user dashboard statistics');
      }
    });
}
